import { render } from "./Quote.vue?vue&type=template&id=1db8a230&scoped=true"
const script = {}

import "./Quote.vue?vue&type=style&index=0&id=1db8a230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db8a230"]])

export default __exports__